import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';

export const Footer = () => {
  const content = useSelector(contentSelector());

  return View({
    content,
  });
};
